import {athleteCompanyDocument} from "./athleteCompanyDocument";

export class CompanyDocument {
    id?: string;
    name: string = '';
    description?: string;
    isMandatory: number = 1;
    hasExpirationDate: number = 1;
    status?: string;
    createdAt?: string;
    updatedAt?: string;
    companyId?: string;
    uploadTime?: string;
    AthleteCompanyDocument?: athleteCompanyDocument;
    UserCompanyDocument?: athleteCompanyDocument;
    modelUrl?: string;
    primaryDocument: number = 0;
    documentTypes?: string= '';

    constructor(raw?: CompanyDocument) {

        if (raw) {
            this.id = raw.id;
            this.name = raw.name;
            this.description = raw.description;
            this.isMandatory = raw.isMandatory;
            this.hasExpirationDate = raw.hasExpirationDate;
            this.companyId = raw.companyId;
            this.modelUrl = raw.modelUrl
            this.primaryDocument = raw.primaryDocument
            this.documentTypes = raw.documentTypes;
            if ( Object.keys(CompanyDocument).length ) {
                this.AthleteCompanyDocument = raw.AthleteCompanyDocument;
                this.UserCompanyDocument = raw.UserCompanyDocument;
            }
        }
    }
}
